import * as Yup from 'yup'
import { setLocale } from 'yup'

import enLocale from './yup-locales/yup-en'

setLocale(enLocale)

export default Yup
